import axios from 'axios'
import store from './store/store'
import Vue from 'vue';
import ElementUI from 'element-ui';
// axios 配置
axios.defaults.timeout = 20000
axios.defaults.maxContentLength=200000
// http request 拦截器
axios.interceptors.request.use(
  config => {
    if (store.state.token) {
      config.headers.Authorization = `${store.state.token}`
    }
    return config
  }
)
axios.interceptors.response.use(
  //接口错误状态处理，也就是说无响应时的处理
  response => {
    //拦截响应，做统一处理 
    return response
  },
  error => {
    console.log(error)
    if (String(error).indexOf('timeout') !== -1) {
      ElementUI.Notification({
        title: '网络超时',
        message: '请检查网络连接，重新刷新页面',
        type: 'error'
      });
    }

  })
export default axios



// WEBPACK FOOTER //
// ./src/http.js